export interface AuthConfig {
  AUTH_TOKEN_KEY: string
  CSS_CLASSNAMES_PREFIX?: string
  DISMISSED_BANNERS: string
  TOP_BAR_BANNER_DISMISSED: string
  ACCOUNT_DISMISSED_BANNER: string
  HAS_CLOSED_GUIDED_SETUP_ONCE: string
  HAS_COMPLETED_ALL_GUIDED_SETUP_STEPS_ONCE: string
  I_AM_TOKEN_KEY: string
  LAST_CLEAR_KEY: string
  LOCALE_KEY: string
  SELECTED_ACCOUNT_KEY: string
  SELECTED_ACCOUNT_INFO: string
  SELECTED_PBX_ID: string
  SIDEBAR_WIDTH_KEY: string
  SIDEBAR_TOGGLE_STATE: string
  THEME_KEY: string
  SKIN_KEY: string
  REBRANDING: string
  RESOLVE_GUIDED_SETUP_CLOSED: string
  GLOBAL_SEARCH_FREQUENT_SEARCHES: string
  TAX_EXEMPTION_BANNER_ID: string
  COPILOT_PINNED: string
}

const prefix = 'lmi-unified-admin'

const common = {
  AUTH_TOKEN_KEY: `${prefix}-auth-token`,
  CSS_CLASSNAMES_PREFIX: `${prefix}`,
  DISMISSED_BANNERS: `${prefix}-dismissed-banners`,
  TOP_BAR_BANNER_DISMISSED: `${prefix}-top-bar-banner-dismissed`,
  ACCOUNT_DISMISSED_BANNER: `${prefix}-account-dismissed-banners`,
  HAS_CLOSED_GUIDED_SETUP_ONCE: `${prefix}-has-closed-guided-setup-once`,
  HAS_COMPLETED_ALL_GUIDED_SETUP_STEPS_ONCE: `${prefix}-has-completed-all-guided-setup-steps-once`,
  I_AM_TOKEN_KEY: `${prefix}-iam-token`,
  LAST_CLEAR_KEY: `${prefix}-last-clear`,
  LOCALE_KEY: `${prefix}-locale`,
  SELECTED_ACCOUNT_KEY: `${prefix}-selected-account-key`,
  SELECTED_ACCOUNT_INFO: `${prefix}-selected-account-info`,
  SELECTED_PBX_ID: `${prefix}-selected-pbx-id`,
  SIDEBAR_WIDTH_KEY: `${prefix}-sidebar-width`,
  SIDEBAR_TOGGLE_STATE: `${prefix}-sidebar-toggle-state`,
  THEME_KEY: `${prefix}-theme`,
  SKIN_KEY: `${prefix}-skin`,
  REBRANDING: `${prefix}-rebranding2021`,
  RESOLVE_GUIDED_SETUP_CLOSED: `${prefix}-resolve-guided-setup-closed`,
  GLOBAL_SEARCH_FREQUENT_SEARCHES: `${prefix}-global-search-frequent-searches`,
  TAX_EXEMPTION_BANNER_ID: 'tax-exemption-info-banner',
  COPILOT_PINNED: `${prefix}-copilot-pinned`,
}

const authConfig: { [key in 'local' | 'development' | 'staging' | 'production']: AuthConfig } = {
  local: {
    ...common,
  },
  development: {
    ...common,
  },
  staging: {
    ...common,
  },
  production: {
    ...common,
  },
}

export default authConfig
